type RecapSourceCostline = {
	costLineType?: string | null
	total?: number | null
	discountPercentage?: number | null
}

export function hasNonZeroDiscountPercentage(
	discountPercentage: unknown
): discountPercentage is number {
	return (
		typeof discountPercentage === 'number' &&
		Number.isFinite(discountPercentage) &&
		discountPercentage !== 0
	)
}

export function hasPositiveTotal(total: unknown): total is number {
	return typeof total === 'number' && total > 0
}

export function shouldIncludeRecapBudgetCostline(
	costLine: RecapSourceCostline
): boolean {
	return (
		hasPositiveTotal(costLine.total) ||
		(costLine.costLineType === 'costLine' &&
			hasNonZeroDiscountPercentage(costLine.discountPercentage))
	)
}
